import React, { Component } from "react";
import MainCards from "../../mainCards";
import { Layout, Menu, Divider } from "antd";
import "./style.css";
import { notification } from "antd";
import {
  WarningTwoTone,
  BarsOutlined,
  FundProjectionScreenOutlined,
  LineChartOutlined,
} from "@ant-design/icons";
const { Sider, Content } = Layout;

class MainPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key: "1",
      collapsed: true,
    };
  }

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  notActiveNotification = () => {
    let placement = "bottomRight";
    const key = `open${Date.now()}`;
    notification.open({
      duration: 5,
      message: "Attention Champion!",
      description: (
        <div id="loading">
          <h3>This feature is under development.</h3>
          <p>Please visit again later, Thanks.</p>
        </div>
      ),
      placement,
      icon: <WarningTwoTone twoToneColor="#BF2F2F" />,
      key,
    });
  };

  render() {
    // console.log(this.props.loader)
    return (
      <div className="mainDiv1s1">
        <Layout className="layOut113">
          <Sider
            collapsible
            collapsed={this.state.collapsed}
            onCollapse={this.onCollapse}
          >
            <div className="logo" />
            <Menu theme="dark" mode="inline" defaultSelectedKeys={["1"]}>
              <Menu.Item
                key="1"
                onClick={() => {
                  this.setState({
                    key: "1",
                  });
                }}
                icon={<BarsOutlined />}
              >
                Courses
              </Menu.Item>
              <Menu.Item
                key="2"
                // onClick={() => {
                // 	this.setState({
                // 		key: "2",
                // 	});
                // }}
                onClick={this.notActiveNotification}
                icon={<LineChartOutlined />}
              >
                Learning
              </Menu.Item>
              <Menu.Item
                key="3"
                // onClick={() => {
                // 	this.setState({
                // 		key: "5",
                // 	});
                // }}
                onClick={this.notActiveNotification}
                icon={<FundProjectionScreenOutlined />}
              >
                Reports
              </Menu.Item>
            </Menu>
          </Sider>

          <Layout className="site-layout">
            {this.state.key === "1" ? (
              <Content
                className="site-layout-background"
                style={{
                  padding: 24,
                  minHeight: 280,
                  textAlign: "center",
                  fontSize: "40px",
                }}
              >
                <div className="marginTop">
                  <Divider>
                    Courses {" (" + this.props.courses.length + ")"}
                  </Divider>
                  <MainCards
                    onPageChange={this.props.onPageChange}
                    courses={this.props.courses}
                    firstCourseID={this.props.firstCourseID}
                    user={this.props.user}
                  />
                </div>
              </Content>
            ) : this.state.key === "2" ? (
              <Content
                className="site-layout-background"
                style={{
                  padding: 24,
                  minHeight: 280,
                  textAlign: "center",
                  fontSize: "40px",
                }}
              >
                <div className="marginTop">
                  <Divider>Video Gallery</Divider>
                </div>
              </Content>
            ) : this.state.key === "3" ? (
              <Content
                className="site-layout-background"
                style={{
                  padding: 24,
                  minHeight: 280,
                  textAlign: "center",
                  fontSize: "40px",
                }}
              >
                <div className="marginTop">
                  <Divider>Reports</Divider>
                </div>
              </Content>
            ) : null}
          </Layout>
        </Layout>
      </div>
    );
  }
}
export default MainPage;
